import { Component, computed, input } from '@angular/core';
import { SpecsLotAddendumViewComponent } from '../specs-lot-addendum-view/specs-lot-addendum-view.component';

@Component({
  selector: 'app-options-tab',
  imports: [SpecsLotAddendumViewComponent],
  templateUrl: './options-tab.component.html',
  styleUrl: './options-tab.component.scss'
})
export class OptionsTabComponent {
  readonly lotId = input.required<string>();
  readonly modelId = input.required<string>();
  readonly elevationId = input.required<string>();
}
